<template>
<v-app>
    <v-card flat>
        <v-card-title><span class="headline">Виконавці :: {{title}}</span></v-card-title>
    </v-card>
    <Comments type="contractors" :id="id"/>
</v-app>
</template>

<script>
import Comments from './Comments.vue'

import {
    HTTP
} from '../http-common'

export default {
    components: {
        Comments
    },
    props: {
        title: String,
        id: Number
    },
    data() {
        return {}
    },

}
</script>
